//get all
const get = '/app-setting'

const AppSettingService = {
  get
}

export default AppSettingService
